import AdminMenu from './AdminMenu';
import UserProfileMenu from './UserProfileMenu';

const menus = {
  AdminMenu,
  UserProfileMenu,
};
export default menus;
